<template>
  <time class="countdown">{{ display }}</time>
</template>

<script>
import { intervalToDuration } from "date-fns";
import toDate from "date-fns-tz/toDate";
export default {
  name: "CountdownClock",
  props: {
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      now: new Date(),
      tick: null,
    };
  },
  computed: {
    remaining() {
      const end = toDate(this.end, {
        timeZone: "Europe/London",
      });

      return intervalToDuration({
        start: this.now,
        end,
      });
    },
    display() {
      const days = this.remaining.days.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const hours = this.remaining.hours.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const mins = this.remaining.minutes.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const secs = this.remaining.seconds.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      return `${days} d : ${hours} h : ${mins} m : ${secs} s`;
    },
  },
  mounted() {
    this.tick = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.countdown {
  color: $color-white;
  font-family: $heading-font-family;
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 30px 0;
  display: block;

  @include respond-above(md) {
    font-size: 20px;
    margin: 0 0 45px 0;
  }
}
</style>
